import React, { useState } from 'react';
import axios from 'axios';

export default function ChangePassword({ onSuccess }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');
    if (newPassword.length < 8) return setError('New password must be at least 8 characters.');
    if (newPassword === currentPassword) return setError('New password must be different from your current password.');
    if (newPassword !== confirmPassword) return setError('Passwords do not match.');
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      await axios.post(`${process.env.REACT_APP_API_URL}/password/change`,
        { currentPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to change password.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%', padding: '10px 12px', border: '1px solid #E5E7EB',
    borderRadius: '6px', fontSize: '13px', color: '#111827',
    outline: 'none', boxSizing: 'border-box'
  };
  const labelStyle = { display: 'block', fontSize: '12px', fontWeight: '600', color: '#374151', marginBottom: '6px' };

  return (
    <div style={{ minHeight: '100vh', background: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '40px', width: '100%', maxWidth: '420px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <div style={{ marginBottom: '28px' }}>
          <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#111827', margin: '0 0 8px 0' }}>Change Your Password</h1>
          <p style={{ fontSize: '13px', color: '#6B7280', margin: 0 }}>For security, you must set a new password before continuing.</p>
        </div>

        {error && (
          <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '6px', padding: '10px 12px', marginBottom: '16px', fontSize: '12px', color: '#B91C1C' }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Current Password</label>
          <input type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} style={inputStyle} placeholder="Enter current password" />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>New Password</label>
          <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={inputStyle} placeholder="Min. 8 characters" />
        </div>
        <div style={{ marginBottom: '24px' }}>
          <label style={labelStyle}>Confirm New Password</label>
          <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} style={inputStyle} placeholder="Re-enter new password"
            onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
        </div>

        <button onClick={handleSubmit} disabled={loading} style={{
          width: '100%', padding: '11px', background: '#1A3A5C', color: '#fff',
          border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600',
          cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1
        }}>
          {loading ? 'Updating...' : 'Set New Password'}
        </button>
      </div>
    </div>
  );
}
